import React from 'react';
import { Modal, Button, Tooltip, Tabs } from 'antd';
import _isEmpty from 'lodash/isEmpty'
import _isEqual from 'lodash/isEqual'
import 'antd/dist/antd.css'
import { CloseCircleOutlined } from "@ant-design/icons";

import { Info, Resources, StaffContact } from '../exhibitorInfo/CompanyInfo'
import CustomScrollbars from '../../utils/CustomScrollbars'
import { SvgModalInfoIcon, SvgResourceIcon, SvgStaffIcon, SvgMeetingIcon } from "../common/SvgIcons";

const { TabPane } = Tabs;
class ExhibitorProfile extends React.Component {
    constructor() {
        super();
        this.state = {
            activeKey: 'info'
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.selectedExhibitor && !_isEqual(prevProps.selectedExhibitor, this.props.selectedExhibitor)) {
            this.setState({ activeKey: 'info' })
        }
    }
    tabChange = (activeKey) => {
        this.setState({ activeKey })
    }
    handleTabData = (selectedInfo) => {
        let media = selectedInfo?.media
        let hideResource = media && _isEmpty(media.links) && _isEmpty(media.pdf) && _isEmpty(media.products) && _isEmpty(media.raffle) && _isEmpty(media.youtube)
        let data = [{
            title: 'Info',
            key: 'info',
            component: <Info {...selectedInfo} />,
            imgUrl: <SvgModalInfoIcon className="icon-size" color={this.props.customThemeStyle.primary_color} />
        }];
        if (!hideResource) {
            data = [...data, {
                title: 'Resources',
                key: 'resource',
                component: <Resources {...selectedInfo} />,
                imgUrl: <SvgResourceIcon className="icon-size" color={this.props.customThemeStyle.primary_color} />
            }]
        }
        if (!_isEmpty(selectedInfo?.contact_info)) {
            data = [...data, {
                title: 'Staff',
                key: 'staff',
                component: <StaffContact {...selectedInfo} />,
                imgUrl: <SvgStaffIcon className="staff-icon-size" color={this.props.customThemeStyle.primary_color} />
            }]
        }
        return data
    }
    handleOnHide = () => {
        this.props.onHide()
        this.setState({ activeKey: 'info' })
    }
    handleClose = () => {
        this.props.handleExhibitorModalClose()
        this.setState({ activeKey: 'info' })
    }
    rendertabContent = (paneKey, data) => {
        data.source_hex = this.props.config?.source_hex;
        let media = data?.media
        let hideResource = media && _isEmpty(media.links) && _isEmpty(media.pdf) && _isEmpty(media.products) && _isEmpty(media.raffle) && _isEmpty(media.youtube)
        if (paneKey === 'info') {
            return <Info {...data} />
        }
        if (!hideResource && paneKey === 'resource') {
            return <Resources {...data} />
        }
        if (!_isEmpty(data?.contact_info) && paneKey === 'staff') {
            return <StaffContact {...data} />
        }
    }

    handleModalWidth = () => {
        let windowWidth = window.innerWidth;
        let result = windowWidth - windowWidth / 2.5;
        if(windowWidth <= 1440 && windowWidth > 768 ){
            result = windowWidth - 200;
        } else if(windowWidth <= 768){
            result = windowWidth - windowWidth / 5.5;
        }
        return result;
    }

    render() {
        let selectedExhibitor = { ...this.props.exhibitors[this.props.selectedExhibitor], ...this.props.exhibitorsInfo[this.props.selectedExhibitor], tagsInfo: this.props.tagsInfo, supportLevel: this.props.supportLevel, customThemeStyle: this.props.customThemeStyle };
        let tabData = this.handleTabData(selectedExhibitor);
        return (<Modal 
            width={this.handleModalWidth()} 
            height={ window.innerHeight - 50}
            bodyStyle={{ display: "contents", top: 10 }} 
            // centered 
            visible={this.props.show} 
            onCancel={this.handleOnHide} 
            footer={null} 
            closable={false} 
            dialogClassName={this.props.fullscreen ? 'publicExhibitorModal' : 'exhibitorModal'} 
        >

            <Tabs
                activeKey={this.state.activeKey}
                onChange={this.tabChange}
                tabPosition="top"
                className="custom-antd-tabs"
                style={{ padding: "20px" }}
            >
                {tabData.map((pane, index) => (
                    <TabPane
                        tab={
                            <Tooltip title={window.innerWidth > 760 ? '' : pane.title} key={index}>
                                <div className={'modal-nav-button'} key={index} onClick={() => this.tabChange(pane.key)}>
                                    <div className="nav-button-image-holder gx-d-flex">
                                        {pane.imgUrl}
                                        <h4 className={`modal-navs app-text-color`}>{pane.title}</h4>
                                    </div>
                                </div>
                            </Tooltip>
                        }
                        key={pane.key}

                    >
                        {pane.key === "staff" ?
                            this.rendertabContent(pane.key, selectedExhibitor)
                            : <CustomScrollbars autoHeight autoHeightMin={300} autoHeightMax={595}>
                                {this.rendertabContent(pane.key, selectedExhibitor)}
                            </CustomScrollbars>
                        }
                        <div className='close-icon-x app-text-color' onClick={this.handleClose}>
                            <CloseCircleOutlined />
                        </div>
                    </TabPane>
                ))}
            </Tabs>

        </Modal>)
    }
}

class ConfirmationModal extends React.Component {
    constructor() {
        super();
    }

    numberWithCommas(x) {
        if (x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else return null;
    }

    render() {
        if (this.props.selectedBooth) {
            return (<Modal show={this.props.show} style={{ opacity: 1 }} dialogClassName={'exhibitorModal'} onHide={this.props.onHide}>

                <Modal.Header>
                    <Modal.Title>Confirm</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to add the selected booth to the cart?
                        <hr />
                    <div className="row">
                        <div className="col-sm-3">
                            <b>Booth No:</b>
                        </div>
                        <div className="col-sm-3">
                            {this.props.selectedBooth['booth_data']['BoothNo']}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-3">
                            <b>Booth Size:</b>
                        </div>
                        <div className="col-sm-3">
                            {this.props.selectedBooth['booth_data']['BoothSize']}
                        </div>
                    </div>
                    {
                        (this.numberWithCommas(this.props.selectedBooth['booth_data']['Amount']) != null) && (<div className="row">
                            <div className="col-sm-3">
                                <b>Cost:</b>
                            </div>
                            <div className="col-sm-3">
                                ${this.numberWithCommas(this.props.selectedBooth['booth_data']['Amount'])}
                            </div>
                        </div>)
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={(e) => { this.props.addToCart(this.props.selectedBooth); this.props.handleConfirmModalClose(); }}>Yes</Button>
                    <Button variant="danger" onClick={this.props.handleConfirmModalClose}>No</Button>
                </Modal.Footer>
            </Modal>);
        } else {
            return null;
        }
    }
}

class ErrorModal extends React.Component {
    constructor() {
        super();
    }

    render() {
        return (<Modal show={this.props.show} style={{ opacity: 1 }} dialogClassName={'exhibitorModal'} onHide={this.props.onHide}>
            <Modal.Header>
                <Modal.Title>Error</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {this.props.errorText}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={this.props.handleModalClose}>Close</Button>
            </Modal.Footer>
        </Modal>);
    }
}

export { ExhibitorProfile, ConfirmationModal, ErrorModal };